import PropTypes from 'prop-types';
import React from 'react';
import { IntroductionPageView } from '../../shared/components/IntroductionPageView';
import manifest from '../manifest.json';

// Placeholder OMB info for this sample form, matching the sibling
// mock-form-prefill app. Replace with real values when adapting this page.
const ombInfo = {
  resBurden: '10',
  ombNumber: '1234-5678',
  expDate: '12/31/2027',
};

const content = {
  formTitle: 'Fill out a sample form',
  formSubTitle:
    'Sample form for exploring VA Design System form patterns (VA Form 00-0000)',
  authStartFormText: 'Start the sample form',
  unauthStartText: 'Start the sample form',
  saveInProgressText:
    'Please complete the sample form to explore VA form patterns in action.',
};

export const IntroductionPage = ({ route }) => {
  const childContent = (
    <>
      <p>
        This sample form shows how VA Design System form patterns work together
        in a real form flow, from this introduction through the review and
        confirmation pages. You can enter example information as you go; nothing
        you enter is submitted to VA.
      </p>

      <h2>Follow these steps to explore the sample form</h2>
      <va-process-list>
        <va-process-list-item header="Prepare">
          <p>
            You don’t need any real information. As you move through the form,
            enter example answers, like a name, date of birth, and address, to
            see how each pattern behaves.
          </p>
          <p>
            Want to explore a single pattern on its own? Use the{' '}
            <va-link href={`${manifest.rootUrl}/index`} text="patterns index" />
            .
          </p>
        </va-process-list-item>
        <va-process-list-item header="Fill out the sample form">
          <p>
            Work through each page to see patterns like name and date of birth,
            mailing address, file upload, and list and loop in a realistic flow.
            Your progress isn’t saved.
          </p>
        </va-process-list-item>
        <va-process-list-item header="Review and submit">
          <p>
            Check your answers on the review page, then submit to reach a sample
            confirmation page. No information is sent to VA.
          </p>
        </va-process-list-item>
      </va-process-list>
    </>
  );

  return (
    <IntroductionPageView
      route={route}
      content={content}
      ombInfo={ombInfo}
      childContent={childContent}
      devOnly={{
        forceShowFormControls: true,
      }}
    />
  );
};

IntroductionPage.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      prefillEnabled: PropTypes.bool,
      savedFormMessages: PropTypes.shape({}),
    }),
    pageList: PropTypes.array,
  }),
};

export default IntroductionPage;
